import styled from 'styled-components';

const DivContainer = styled.div`
  flex-grow: 1;
  height: 100%;
`;

export default DivContainer;
